export default {
  facet: {
    date: {
      custom: "Custom Date Range"
    }
  }
}
